document.addEventListener('DOMContentLoaded', function() {
  // ===============================
  // 필터 토글 관련
  // ===============================
  const openFilterBtn = document.getElementById('open-filter');
  const filterContainer = document.querySelector('.filter-container');
  const filterBackdrop = document.getElementById('filter-backdrop');

  const openFilter = () => {
    filterContainer.classList.add('open');
    filterBackdrop.classList.remove('hidden');
    openFilterBtn.textContent = 'Close';
    // 스크롤 막기
    document.body.style.overflow = 'hidden';
  };

  const closeFilter = () => {
    filterContainer.classList.remove('open');
    filterBackdrop.classList.add('hidden');
    openFilterBtn.textContent = 'Sort & filter';
    // 스크롤 복원
    document.body.style.overflow = '';
  };

  openFilterBtn.addEventListener('click', function() {
    if (filterContainer.classList.contains('open')) {
      closeFilter();
    } else {
      openFilter();
    }
  });

  filterBackdrop.addEventListener('click', closeFilter);

  // ===============================
  // 제품 요소들 가져오기
  // ===============================
  const productElements = document.querySelectorAll('.product-li');

  // ===============================
  // 필터 적용 함수 (사이즈는 OR, 컬러는 OR, 두 그룹은 AND)
  // ===============================
  function applyFilters() {
    // active 사이즈 버튼들의 normalized 값 배열
    const activeSizeButtons = document.querySelectorAll('.size-filter-button.active');
    const activeSizes = Array.from(activeSizeButtons).map(btn => btn.dataset.filterValue);

    // active 컬러 버튼들의 normalized 값 배열
    const activeColorButtons = document.querySelectorAll('.color-filter-button.active');
    const activeColors = Array.from(activeColorButtons).map(btn => btn.dataset.filterValue);

    productElements.forEach(product => {
      const tagsStr = product.getAttribute('data-tags');
      if (!tagsStr) {
        product.style.display = 'none';
        return;
      }
      // 원래 태그 배열 (공백 제거)
      const tags = tagsStr.split(',').map(tag => tag.trim());
      // 사이즈 비교용: 소문자로만 변환 (띄어쓰기는 그대로)
      const normalizedSizeTags = tags.map(tag => tag.toLowerCase());
      // 컬러 비교용: 소문자로 변환하고 띄어쓰기는 제거
      const normalizedColorTags = tags.map(tag => tag.toLowerCase().replace(/\s/g, ''));

      // 사이즈 조건: activeSizes가 있을 경우, 제품 태그 중 하나라도 일치해야 함.
      let sizeMatch = activeSizes.length > 0 ? activeSizes.some(val => normalizedSizeTags.includes(val)) : true;
      // 컬러 조건: activeColors가 있을 경우, 제품 태그 중 하나라도 일치해야 함.
      let colorMatch = activeColors.length > 0 ? activeColors.some(val => normalizedColorTags.includes(val)) : true;

      product.style.display = (sizeMatch && colorMatch) ? '' : 'none';
    });
  }

  // ===============================
  // 사이즈 필터 생성 (대소문자 구분 없이 비교)
  // ===============================
  const sizeOrder = ['0', '1', 'OS', 'M', 'L', 'XL', '230', '235', '240', '245', '250', '255', '260', '265', '270', '275', '280', '5', '6', '7', '8', '9'];
  const lowerSizeOrder = sizeOrder.map(size => size.toLowerCase());
  const availableSizes = new Set();
  productElements.forEach(product => {
    const tagsStr = product.getAttribute('data-tags');
    if (tagsStr) {
      const tags = tagsStr.split(',').map(tag => tag.trim().toLowerCase());
      tags.forEach(tag => {
        if (lowerSizeOrder.includes(tag)) {
          availableSizes.add(tag);
        }
      });
    }
  });
  const filterSizeElement = document.querySelector('.filter-size');

  lowerSizeOrder.forEach((sizeLower, index) => {
    if (availableSizes.has(sizeLower)) {
      const btn = document.createElement('button');
      btn.className = 'size-filter-button';
      btn.textContent = sizeOrder[index]; // 원래 텍스트 그대로 (대소문자 유지)
      btn.dataset.filterValue = sizeLower; // 비교용 normalized 값
      btn.addEventListener('click', function() {
        btn.classList.toggle('active');
      });
      if (filterSizeElement) {
        filterSizeElement.appendChild(btn);
      }
    }
  });

  // ===============================
  // 컬러 필터 생성 (대소문자 및 띄어쓰기 무시)
  // ===============================
  const colorOrder = [
    'black',
    'white',
    'grey',
    'charcoal',
    'light blue',
    'light grey',
    'beige',
    'wine',
    'burgundy',
    'brown',
    'blue',
    'dark brown',
    'stripe',
    'ivory',
    'navy',
    'mid blue',
    'dark grey',
    'pink',
    'lilac',
    'purple',
    'mint',
    'blue grey'
  ];
  const lowerColorOrder = colorOrder.map(color => color.toLowerCase().replace(/\s/g, ''));
  const availableColors = new Set();
  productElements.forEach(product => {
    const tagsStr = product.getAttribute('data-tags');
    if (tagsStr) {
      const tags = tagsStr.split(',').map(tag => tag.trim().toLowerCase().replace(/\s/g, ''));
      tags.forEach(tag => {
        if (lowerColorOrder.includes(tag)) {
          availableColors.add(tag);
        }
      });
    }
  });
  const filterColorElement = document.querySelector('.filter-color');

  lowerColorOrder.forEach((colorNorm, index) => {
    if (availableColors.has(colorNorm)) {
      const btn = document.createElement('button');
      btn.className = 'color-filter-button';
      btn.textContent = colorOrder[index]; // 원본 텍스트 (띄어쓰기 포함)
      btn.dataset.filterValue = colorNorm; // 비교용 normalized 값
      // 원본 텍스트를 dataset에 저장하여 토글 시 활용
      btn.dataset.originalText = colorOrder[index];
      btn.addEventListener('click', function() {
        btn.classList.toggle('active');
        if (btn.classList.contains('active')) {
          btn.textContent = '↳ ' + btn.dataset.originalText;
        } else {
          btn.textContent = btn.dataset.originalText;
        }
      });
      if (filterColorElement) {
        filterColorElement.appendChild(btn);
      }
    }
  });

  // ===============================
  // 미리 HTML에 만들어둔 Apply와 Clear 버튼 선택
  // ===============================
  const applyButton = document.querySelector('.apply-filter');
  const clearButton = document.querySelector('.clear-filter');

  // Apply 버튼: 현재 active 상태의 필터를 적용하고 필터를 닫음
  if (applyButton) {
    applyButton.addEventListener('click', function() {
      applyFilters();
      closeFilter();
    });
  }

  // Clear 버튼: 모든 필터 버튼의 active 상태 제거 및 모든 제품 보이기
  if (clearButton) {
    clearButton.addEventListener('click', function() {
      // 사이즈 필터 버튼 초기화
      document.querySelectorAll('.size-filter-button.active').forEach(btn => btn.classList.remove('active'));
      // 컬러 필터 버튼 초기화 (원본 텍스트로 복원)
      document.querySelectorAll('.color-filter-button.active').forEach(btn => {
        btn.classList.remove('active');
        btn.textContent = btn.dataset.originalText;
      });
      // 모든 제품 다시 표시
      productElements.forEach(product => {
        product.style.display = '';
      });
    });
  }
});
